export default __webpack_public_path__ + "static/media/16-confused-face_1f615.4fea83eb.png";